import HomeMerchantPage from "@/modules/merchant/pages";
import CustomerMyOrganizationPage from "@/modules/merchant/pages/customerMyOrganization";
import CustomerMyOrganizationDetailPage from "@/modules/merchant/pages/customerMyOrganization/customerMyOrganizationDetailPage";
import CustomerUserDetail from "@/modules/merchant/pages/customerMyOrganization/customerUserDetail";
import CustomerOrganizationPage from "@/modules/merchant/pages/customerOrganization";
import CustomerServicePage from "@/modules/merchant/pages/customerService";
import FinancePages from "@/modules/merchant/pages/finance";
import InternalReportsInventoryPage from "@/modules/merchant/pages/internalReportsInventory";
import ProfileMerchantPage from "@/modules/merchant/pages/ProfileMerchant";
import WalletBalanceReportsPage from "@/modules/merchant/pages/walletBalanceReports";
import WalletCardManagementPage from "@/modules/merchant/pages/walletCardManagement";
import WalletCreditBalanceReportsPage from "@/modules/merchant/pages/walletCreditBalanceReports";
import WalletFinancialReportsPage from "@/modules/merchant/pages/walletFinancialReports";
import WalletWithdrawalReportsPage from "@/modules/merchant/pages/walletWithdrawalReports";
import WithdrawWalletPage from "@/modules/merchant/pages/withdrawWallet";
import LoginPage from "@/modules/user/pages/login";
import PrivateRoute from "./PrivateRoute";
import MessageListPage from "@/modules/merchant/pages/messageList";
import GoldReports from "@/modules/merchant/pages/GoldReports/goldReports";
import GoldReportsInternal from "@/modules/merchant/pages/GoldReports/GoldReportsInternal";
import GoldReportsExternal from "@/modules/merchant/pages/GoldReports/GoldReportsExternal";
/**

userRoutesAcceptor

آرایه‌ای از مسیرهای اپلیکیشن برای کاربران با نقش پذیرنده (Merchant) که شامل مسیرهای عمومی و خصوصی است.

مسیرهای خصوصی با استفاده از PrivateRoute محافظت شده‌اند تا تنها کاربران دارای توکن دسترسی داشته باشند.

مسیرهای موجود:

"/" : صفحه اصلی پذیرنده

"/finance" : صفحه مالیات‌ها و تراکنش‌ها

"/profile" : صفحه پروفایل پذیرنده

"/withdraw-wallet" : برداشت از کیف پول

"/wallet-balance-reports" : گزارش موجودی کیف پول

"/wallet-credit-balance-reports" : گزارش اعتبار کیف پول

"/wallet-financial-reports" : گزارش مالی کیف پول

"/wallet-withdrawal-reports" : گزارش برداشت‌ها

"/wallet-card-management" : مدیریت کارت‌های کیف پول

"/internal-reports-inventory" : گزارش ها داخلی انبار

"/customer-service" : صفحه خدمات مشتری

"/customer-organization" : مدیریت سازمان‌های مشتری

"/customer-my-organization" : لیست سازمان‌های متعلق به کاربر

"/customer-my-organization/:id" : جزئیات سازمان مشخص

"/customer-my-organization/user-details/:id" : جزئیات کاربران سازمان

"/login" : صفحه ورود (عمومی)

@type {Array<{ path: string, element: JSX.Element }>}
*/

export const userRoutesAcceptor = [
  {
    path: "/",
    element: (
      <PrivateRoute>
        <HomeMerchantPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/finance",
    element: (
      <PrivateRoute>
        <FinancePages />
      </PrivateRoute>
    ),
  },
  {
    path: "/profile",
    element: (
      <PrivateRoute>
        <ProfileMerchantPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/withdraw-wallet",
    element: (
      <PrivateRoute>
        <WithdrawWalletPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/wallet-balance-reports",
    element: (
      <PrivateRoute>
        <WalletBalanceReportsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/wallet-credit-balance-reports",
    element: (
      <PrivateRoute>
        <WalletCreditBalanceReportsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/wallet-financial-reports",
    element: (
      <PrivateRoute>
        <WalletFinancialReportsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/wallet-withdrawal-reports",
    element: (
      <PrivateRoute>
        <WalletWithdrawalReportsPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/wallet-card-management",
    element: (
      <PrivateRoute>
        <WalletCardManagementPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/internal-reports-inventory",
    element: (
      <PrivateRoute>
        <InternalReportsInventoryPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/Gold-reports",
    element: (
      <PrivateRoute>
        <GoldReports />
      </PrivateRoute>
    ),
  },
  // {
  //   path: "/Gold-reports-internal",
  //   element: (
  //     <PrivateRoute>
  //       <GoldReportsInternal />
  //     </PrivateRoute>
  //   ),
  // },
  // {
  //   path: "/Gold-reports-external",
  //   element: (
  //     <PrivateRoute>
  //       <GoldReportsExternal />
  //     </PrivateRoute>
  //   ),
  // },
  {
    path: "/customer-service",
    element: (
      <PrivateRoute>
        <CustomerServicePage />
      </PrivateRoute>
    ),
  },
  {
    path: "/customer-organization",
    element: (
      <PrivateRoute>
        <CustomerOrganizationPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/customer-my-organization",
    element: (
      <PrivateRoute>
        <CustomerMyOrganizationPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/customer-my-organization/:id",
    element: (
      <PrivateRoute>
        <CustomerMyOrganizationDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: "/customer-my-organization/user-details/:id",
    element: (
      <PrivateRoute>
        <CustomerUserDetail />
      </PrivateRoute>
    ),
  },
  {
    path: "/list-message",
    element: (
      <PrivateRoute>
        <MessageListPage />
      </PrivateRoute>
    )
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
];
